import {toLower, get, isString} from 'lodash'
import debug from 'debug'

// All functions accept an error object as a parameter and will be parsed and proxied to logger.error(...)
function sendLog (callback = () => {}, type = 'info', namespace = '', tags, message, ...args) {
  const isCritical = type === 'critical'
  if (isCritical || message instanceof Error) {
    type = 'error'
  }

  // Hone namespace further by warning type
  namespace = `${namespace} (${type.toUpperCase()}) ${isCritical ? '(Critical!)' : ''}`

  // Print out the message with console[type] or console.log() if the type is not supported
  const log = debug(namespace)
  log.log = get(console, type, console.log).bind(console)

  log(message, ...args)

  if (!message) {
    // No message sent - return
    return
  }

  callback(message, type, tags, args)
}

const createLogger = (namespace, tags = [], callback = () => {}, criticalCallback = () => {}) => {
  tags = tags.map(toLower)

  const _sendLog = (type, ...args) => sendLog(callback, type, namespace, tags, ...args)
  return {
    critical: (...args) => {
      criticalCallback(tags, ...args)
      _sendLog('critical', ...args)
    },
    error: (...args) => _sendLog('error', ...args),
    warn: (...args) => _sendLog('warn', ...args),
    info: (...args) => _sendLog('info', ...args),
    debug: (...args) => _sendLog('debug', ...args),
    addNamespace: (ns, nt = []) => {
      if (ns && !tags.includes(toLower(ns)) && !nt.includes(toLower(ns))) {
        nt.push(ns)
      }
      return createLogger(`${namespace ? namespace + ':' : ''}${ns}`, nt.concat(tags), callback)
    }
  }
}

let __debugLogger = createLogger('XXX:TEMP:DEBUG')
const _debug = (...args) => {
  let __l = __debugLogger
  if (isString(args[0])) {
    // Changes color based on unique namespace
    __l = __debugLogger.addNamespace(args[0].split(' ')[0])
  } else {
    args = ['', ...args]
  }
  __l.warn(...args) // Warn to get a stack trace
}

export default {create: createLogger, debug: _debug}



// WEBPACK FOOTER //
// ./client/webrtc/logger.js